var _path, _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMembershipPackagesHealthCardBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 726,
    viewBox: "0 0 349 726",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2590_419)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58173 3.58172 0 8 0H341C345.418 0 349 3.58172 349 8V718C349 722.418 345.418 726 341 726H8C3.58172 726 0 722.418 0 718V8Z",
    fill: "#0370DF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2590_419)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2590_419",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: 2,
    width: 531,
    height: 726
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: 728,
    width: 726,
    height: 531,
    transform: "rotate(-90 -8 728)",
    fill: "url(#paint0_linear_2590_419)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2590_419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.128 728C332.128 728 347.71 669.777 402.25 654.755C454.532 640.388 468.586 581.207 468.586 581.207",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.914 728C305.914 728 323.899 656.569 389.726 638.17C452.566 620.627 468.586 548.087 468.586 548.087",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.627 728C279.627 728 300.088 643.412 377.055 621.635C450.673 600.866 468.586 514.968 468.586 514.968",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.413 728C253.413 728 276.277 630.205 364.531 605.05C448.707 581.106 468.586 481.849 468.586 481.849",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.199 728C227.199 728 252.466 616.998 351.934 588.466C446.741 561.345 468.586 448.78 468.586 448.78",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.912 728C200.912 728 228.582 603.841 339.336 571.931C444.848 541.534 468.586 415.661 468.586 415.661",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.698 728C174.698 728 204.844 590.633 326.739 555.346C442.882 521.774 468.586 382.542 468.586 382.542",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.484 728C148.484 728 181.033 577.426 314.215 538.812C440.916 502.013 468.586 349.422 468.586 349.422",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.197 728C122.197 728 157.149 564.269 301.545 522.227C439.022 482.252 468.586 316.354 468.586 316.354",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9833 728C95.9833 728 133.338 551.062 288.947 505.693C437.056 462.492 468.586 283.234 468.586 283.234",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6966 728C69.6966 728 109.527 537.854 276.35 489.108C435.09 442.731 468.586 250.115 468.586 250.115",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4826 728C43.4826 728 85.7163 524.697 263.753 472.574C433.197 422.97 468.586 216.996 468.586 216.996",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2686 728C17.2686 728 61.9052 511.49 251.228 455.989C431.231 403.21 468.586 183.877 468.586 183.877",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.01823 728C-9.01823 728 38.0942 498.283 238.558 439.404C429.265 383.449 468.586 150.808 468.586 150.808",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35.2322 728C-35.2322 728 14.2831 485.126 226.034 422.869C427.372 363.688 468.586 117.688 468.586 117.688",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61.4461 728C-61.4461 728 -9.52784 471.918 213.437 406.285C425.406 343.928 468.586 84.5693 468.586 84.5693",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-87.733 728C-87.733 728 -33.4118 458.711 200.839 389.75C423.44 324.167 468.586 51.4502 468.586 51.4502",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-113.947 728C-113.947 728 -57.1499 445.554 188.242 373.165C421.546 304.406 468.586 18.3812 468.586 18.3812",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5117 2.0035C22.5117 2.0035 6.92893 60.2268 -47.6107 75.249C-99.893 89.6158 -113.947 148.797 -113.947 148.797",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7969 2.00345C48.7969 2.00345 30.8112 73.4342 -35.015 91.8337C-97.9286 109.427 -113.948 181.916 -113.948 181.916",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0117 2.00104C75.0117 2.00104 54.5503 86.5887 -22.4169 108.366C-95.9616 129.135 -113.947 214.982 -113.947 214.982",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.229 2.00319C101.229 2.00319 78.3641 99.7982 -9.88961 124.953C-94.0656 148.948 -113.945 248.154 -113.945 248.154",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.516 2.00318C127.516 2.00318 102.248 113.006 2.78077 141.538C-92.0993 168.708 -113.944 281.273 -113.944 281.273",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.727 2.00301C153.727 2.00301 126.056 126.162 15.3022 158.072C-90.1363 188.469 -113.947 314.393 -113.947 314.393",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.939 2.00255C179.939 2.00255 149.793 139.369 27.8984 174.656C-88.2441 208.229 -113.948 347.461 -113.948 347.461",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.229 2.00053C206.229 2.00053 173.679 152.575 40.4979 191.189C-86.2758 227.988 -113.946 380.578 -113.946 380.578",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.441 2.00038C232.441 2.00038 197.489 165.731 53.0941 207.773C-84.3837 247.748 -113.947 413.697 -113.947 413.697",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.656 2.00227C258.656 2.00227 221.301 178.941 65.6922 224.309C-82.4167 267.511 -113.946 446.818 -113.946 446.818",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.943 2.00176C284.943 2.00176 245.113 192.148 78.2899 240.894C-80.4503 287.271 -113.946 479.887 -113.946 479.887",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.158 2.00171C311.158 2.00171 268.925 205.304 90.888 257.428C-78.5562 307.031 -113.945 513.006 -113.945 513.006",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.369 2.00174C337.369 2.00174 292.733 218.512 103.409 274.013C-76.5932 326.792 -113.948 546.125 -113.948 546.125",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.656 2.00147C363.656 2.00147 316.544 231.719 116.08 290.598C-74.6269 346.552 -113.948 579.244 -113.948 579.244",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.869 2.00335C389.869 2.00335 340.354 244.878 128.603 307.134C-72.7348 366.315 -113.949 612.365 -113.949 612.365",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.088 2.00094C416.088 2.00094 364.17 258.083 141.205 323.716C-70.7639 386.073 -113.944 645.432 -113.944 645.432",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.373 2.0029C442.373 2.0029 388.052 271.292 153.801 340.253C-68.7995 405.886 -113.946 678.553 -113.946 678.553",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.586 2.00277C468.586 2.00277 411.789 284.449 166.397 356.837C-66.9073 425.647 -113.947 711.672 -113.947 711.672",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2590_419",
    x1: 355,
    y1: 728,
    x2: 355,
    y2: 1214.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2590_419"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58173 3.58172 0 8 0H341C345.418 0 349 3.58172 349 8V718C349 722.418 345.418 726 341 726H8C3.58172 726 0 722.418 0 718V8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2590_419"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9 728L-9.00003 -63L299 -63C334.346 -63 363 -34.3462 363 0.99998L363 664C363 699.346 334.346 728 299 728L-9 728Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipPackagesHealthCardBg);
export default __webpack_public_path__ + "static/media/membership-packages-health-card-bg.b10517b2b508e9d59dc87f2858d4649b.svg";
export { ForwardRef as ReactComponent };